export default __webpack_public_path__ + "static/Underarm_Top-Bottom-dc71bf844f543b25ec96147ab65844f9.jpg";